const catchAsync = (callBack) => {
  return (...rest) =>
    callBack(...rest).catch((error) => {
      console.log('error:', error);
      throw error;
    });
};

export default catchAsync;